import { Navigate, Outlet, Route, Routes } from "react-router-dom"

import { NAMES_ROUTES } from "@/const/routes.constants"
import { isFeatureFlagMaybe } from "@/domain/user"
import { isSelfHosted } from "@/helpers/self-hosted.helper"
import { useFeatureFlags } from "@/hooks/useUser"
import { ComingSoonPage } from "../ComingSoonPage"
import { AdrManagementPage } from "./components/pages/AdrManagementPage"
import { DataProvider } from "./components/pages/AdrManagementPage/components/organisms/DataProvider"
import { AdrPage } from "./components/pages/AdrPage"
import { IssuesPage } from "./components/pages/IssuesPage"

export const TriagePage = () => {
  const { TRIAGE } = NAMES_ROUTES
  const notSelfHosted = !isSelfHosted()
  const adrIncidentsFF = useFeatureFlags("adrIncidentsEnabled")
  const showIncidentsPage =
    !!adrIncidentsFF || isFeatureFlagMaybe(adrIncidentsFF)

  return (
    <Routes>
      <Route path={`/${TRIAGE.ISSUES}`} element={<IssuesPage />} />
      {notSelfHosted && (
        <Route
          element={
            <DataProvider>
              <Outlet />
            </DataProvider>
          }
        >
          <Route
            path={`/${TRIAGE.INCIDENTS}`}
            element={
              showIncidentsPage ? (
                <AdrManagementPage />
              ) : (
                <ComingSoonPage keyPage="incidents" />
              )
            }
          />
          <Route path={`/${TRIAGE.INCIDENTS}/:id`} element={<AdrPage />} />
        </Route>
      )}
      <Route
        path="/*"
        element={<Navigate to={`/${TRIAGE.ROOT}/${TRIAGE.ISSUES}`} replace />}
      />
    </Routes>
  )
}
